import React from 'react';

import Action from '@components/Button/Action';
import Header from '@components/Modals/Header';
import Image from '@components/Image';

import styles from './Finish.module.scss';
import { useSelector } from 'react-redux';
import { selectIntegrationByPlatform } from '@reducers/user/integrations';
import { AppleDeviceIntegrationProvider } from '@models/Integration';
import {
  supportLinkSlugForDeviceIntegrationType,
  titleForDeviceIntegrationType,
} from '@components/Integrations/utils';

const bubbles = '/img/messages/bubbles-hug.png';
const bubblesLight = '/img/messages/bubbles-hug-light.png';

const syncedItemForProvider: Record<AppleDeviceIntegrationProvider, string> = {
  'apple-messages': 'messages',
  'apple-phone-log': 'phone call history',
};

const verbForSyncingProvider: Record<AppleDeviceIntegrationProvider, string> = {
  'apple-messages': 'are',
  'apple-phone-log': 'is',
};

const inlineLabelForProvider: Record<AppleDeviceIntegrationProvider, string> = {
  ...titleForDeviceIntegrationType,
  'apple-phone-log': 'your phone call history',
};

function renderTitle(provider, status, lastImport) {
  if (status.syncing) {
    return `Syncing ${syncedItemForProvider[provider]}…`;
  }

  if (!status.syncing && !lastImport) {
    return 'Preparing to sync…';
  }

  return "You're all set!";
}

export default function Finish({ provider, next, onClose, syncStatus, forceDarkMode }) {
  const integration = useSelector(selectIntegrationByPlatform(provider));

  return (
    <div className={styles.container}>
      <div className="modal-content">
        <Header.Plain onClose={onClose} />
        <Image
          className={styles.image}
          dark={bubbles}
          light={forceDarkMode ? bubbles : bubblesLight}
          width="200px"
        />
        <h3 className="text-default">
          {renderTitle(provider, syncStatus, integration?.status?.last_import)}
        </h3>
        <p>
          {!syncStatus?.syncing && integration?.status?.last_import
            ? `Your new contacts from ${inlineLabelForProvider[provider]} have been created successfully.`
            : `Your ${syncedItemForProvider[provider]} ${verbForSyncingProvider[provider]} currently syncing, and you should see contacts appear shortly.`}
        </p>
        <p>
          <a
            className="text-default"
            href={`https://go.clay.earth/${supportLinkSlugForDeviceIntegrationType[provider]}`}
            target="_blank"
          >
            Learn more
          </a>{' '}
          about our {titleForDeviceIntegrationType[provider]} integration.
        </p>

        <div className={styles.actions}>
          <Action type="button" block onClick={next} forceDarkMode={forceDarkMode}>
            Done
          </Action>
        </div>
      </div>
    </div>
  );
}
